import { render, staticRenderFns } from "./AsItemCard.vue?vue&type=template&id=ad859710&scoped=true"
import script from "./AsItemCard.vue?vue&type=script&lang=js"
export * from "./AsItemCard.vue?vue&type=script&lang=js"
import style0 from "./AsItemCard.vue?vue&type=style&index=0&id=ad859710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad859710",
  null
  
)

export default component.exports